(function ENotifyD($, Adzuki)
{
	"use strict";

	// eslint-disable-next-line no-unused-vars
	var ENotifyD = function ENotifyD(url, clientId, groupIds, eventHandler)
	{
		var clientIdHash = 0,
		    i,
		    groupIdsStr;

		this.RETRY_INTERVAL            = 1000; // 1 min
		this.LISTEN_FOR_EVENTS_TIMEOUT = 300000; // 5 mins

		this.url          = url;
		this.clientId     = clientId;
		this.groupIds     = groupIds;
		this.eventHandler = eventHandler;

		this.setSessionCookie = function setSessionCookie(name, value)
		{
			var nameParam  = 'eNotifyD_' + name;

			document.cookie = nameParam + '=' + escape(value) + '; domain=' + Adzuki.cookie_domain + '; path=/; ';

			return;
		};

		this.getSessionCookie = function getSessionCookie(name)
		{
			var nameParam  = 'eNotifyD_' + name,
			    valueIndex = document.cookie.indexOf(nameParam + '=');

			if (valueIndex === -1)
			{
				return null;
			}

			valueIndex += (nameParam.length + 1);

			for (i = valueIndex; i < document.cookie.length && document.cookie[i] !== ';'; i++)
			{
				// nothing to do
			}

			return document.cookie.substr(valueIndex, (i - valueIndex));
		};

		this.processEvents = function processEvents()
		{
			var self         = this,
			    handleEvents = true,
			    events       = JSON.parse(this.HTTPObj.responseText),
			    eventId;

			clearTimeout(this.listenForEventsTimeoutObj);

			for (eventId in events)
			{
				if ({}.hasOwnProperty.call(events, eventId))
				{
					if (handleEvents)
					{
						this.eventHandler(events[eventId]);
					}

					this.lastEventId = eventId;
				}
			}

			this.setSessionCookie(this.lastEventIdCookieName, this.lastEventId);

			setTimeout(function timeout() { self.listenForEvents(); }, 1);

			return;
		};

		this.listenForEvents = function listenForEvents()
		{
			var self = this;

			this.HTTPObj.abort();

			this.HTTPObj.ontimeout = function ontimeout()
			{
				// nothing to do
			};

			this.HTTPObj.onerror = function onerror()
			{
				// nothing to do
			};

			this.HTTPObj.onload = function onload()
			{
				// nothing to do
			};

			this.HTTPObj.ontimeout = function ontimeout()
			{
				clearTimeout(self.listenForEventsTimeoutObj);

				setTimeout(function timeout()
				{
					self.listenForEvents();

					return;
				}, self.RETRY_INTERVAL);

				return;
			};

			this.HTTPObj.onerror = this.HTTPObj.ontimeout;

			this.HTTPObj.onload = function onload()
			{
				self.processEvents();

				return;
			};

			this.listenForEventsTimeoutObj = setTimeout(function timeout()
			{
				self.listenForEvents();

				return;
			}, this.LISTEN_FOR_EVENTS_TIMEOUT);

			this.HTTPObj.open('POST', this.url, true);

			this.HTTPObj.send(this.clientId + '|' + ((this.lastEventId === null) ? '0' : this.lastEventId) + '|' + this.groupIds);

			return;
		};

		this.clientId = this.clientId.replace(/\\/g, '\\\\').replace(/\|/g, '\\|');

		if (this.groupIds instanceof Array)
		{
			groupIdsStr = '';

			for (i = 0; i < this.groupIds.length; i++)
			{
				groupIdsStr += this.groupIds[i].replace(/\\/g, '\\\\').replace(/\|/g, '\\|') + '|';
			}

			this.groupIds = groupIdsStr.substr(0, (groupIdsStr.length - 1));
		}

		this.lastEventIdCookieName = 'enotifyd';

		for (i = 0; i < this.clientId.length; i++)
		{
			clientIdHash  = (((clientIdHash << 5) - clientIdHash) + this.clientId.charCodeAt(i)) | 0;
		}

		this.lastEventIdCookieName += (clientIdHash >>> 0);

		this.lastEventId = this.getSessionCookie(this.lastEventIdCookieName);

		try
		{
			// eslint-disable-next-line no-undef
			this.HTTPObj = new XDomainRequest();
		}
		catch (XDRError)
		{
			try
			{
				this.HTTPObj = new XMLHttpRequest();
			}
			catch (XHRError)
			{
				return;
			}
		}

		this.listenForEvents();

		return;
	};

	$(document).ready(function documentReady()
	{
		var protocol,
		    host,
		    port,
		    groupIds,
			eventHandler;

		if (
			(
				Adzuki.app !== 'Web'
				&& !Adzuki.cpcentral
			) || (
				Adzuki.cpcentral
				&& Adzuki.mobile_login
			)
		) {
			if (Adzuki.init_page !== 'main/mobileIndex') {
				return;
			}
		}

		protocol = document.location.href.match(/(http[^:]*)/)[1].toLowerCase();
		host     = document.location.href.match(/http[^:]*:\/\/([^:\/]*)/)[1].toLowerCase();
		port     = 880;

		if (protocol === 'https') {
			if (host.indexOf('devcp.us') === -1) {
				port = 4443;
			} else {
				port = 8082;
			}
		}

		if (Adzuki.app === 'Web') {
			groupIds = [
				'clients',
				'website_clients',
				'website_' + Adzuki.website_id + '_clients',
				'franchise_' + Adzuki.franchise_id + '_clients'
			];

			if (Adzuki.client_id !== null) {
				groupIds.push('client_' + Adzuki.client_id);
			}

			if (Adzuki.lp_session_id !== null) {
				groupIds.push('lp_session_' + Adzuki.lp_session_id + '_clients');
			}

			Adzuki.ENotifyD = new ENotifyD(
				(protocol + '://' + host + ':' + port),
				Adzuki.php_sess_id,
				groupIds,
				function eventHandler(event) {
					var event_data     = JSON.parse(event),
					    valid_handlers = [];

					// TEMPORARY TO BE BACKWARDS COMPATIBLE
					if (event_data['eventHandler'] === 'clientChat.eventHandler') {
						event_data['eventHandler'] = 'Adzuki.ClientChat.eventHandler';
					}

					if (!Adzuki.dev || Adzuki.dev_chat) {
						valid_handlers.push('Adzuki.ClientChat.eventHandler');
					}

					// live planner
					valid_handlers.push('Adzuki.LivePlanner.webEventHandler');

					if (valid_handlers.indexOf(event_data['eventHandler']) === -1) {
						return;
					}

					// eslint-disable-next-line no-eval
					eval(event_data['eventHandler'] + '(event_data);');
				}
			);
		} else {
			groupIds = [
				'agent_' + Adzuki.agent_id,
				'agents',
				'franchise_' + Adzuki.franchise_id + '_agents',
			];

			eventHandler = function eventHandler(event) {
				var event_data     = JSON.parse(event),
					valid_handlers = [];

				if (!Adzuki.dev || Adzuki.dev_chat) {
					valid_handlers.push('Adzuki.AgentChat.eventHandler');
				}

				// CP Central Notifications
				valid_handlers.push('Adzuki.CpcentralNotifications.cpmaxxEventHandler');

				// live planner
				valid_handlers.push('Adzuki.LivePlanner.cpmaxxEventHandler');

				// broadcast
				valid_handlers.push('Adzuki.Broadcast.broadcastEventHandler');

				if (valid_handlers.indexOf(event_data['eventHandler']) === -1) {
					return;
				}

				// eslint-disable-next-line no-eval
				eval(event_data['eventHandler'] + '(event_data);');
			};

			Adzuki.ENotifyD = new ENotifyD(
				(protocol + '://' + host + ':' + port),
				'agent_' + Adzuki.agent_id + '_' + Adzuki.php_sess_id,
				groupIds,
				eventHandler
			);
		}
	});

}(jQuery, window.Adzuki || {}));
